module.exports = __webpack_public_path__ + "app/img/home_9@2x.47a3cd39.png";